export const LOGIN_PRESENTATIONS = {
    'full-sheet-blurred': true,
    'full-sheet': true,
    'bottom-sheet-blurred': true,
    'bottom-sheet-gradient': true,
    'centered-sheet': true,
    'inset-centered-sheet': true,
    'image-modal': true,
};
//# sourceMappingURL=loginAttemptTypes.js.map